import { render } from "./OttoAccordion.vue?vue&type=template&id=023ed859&scoped=true&ts=true"
import script from "./OttoAccordion.vue?vue&type=script&lang=ts"
export * from "./OttoAccordion.vue?vue&type=script&lang=ts"

import "./OttoAccordion.vue?vue&type=style&index=0&id=023ed859&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023ed859"]])

export default __exports__